/* unplugin-vue-components disabled */import script from "./DqlyList.vue?vue&type=script&lang=ts&setup=true"
export * from "./DqlyList.vue?vue&type=script&lang=ts&setup=true"

import "./DqlyList.vue?vue&type=style&index=0&id=07075b07&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07075b07"]])

export default __exports__